import { Component, OnInit } from "@angular/core";
import { PlanService } from "../plan/plan.service";

@Component({
  selector: "app-finance",
  templateUrl: "./finance.component.html",
  styleUrls: ["./finance.component.scss"],
  standalone: false,
})
export class FinanceComponent implements OnInit {
  constructor(private service: PlanService) {}

  ngOnInit(): void {
    void this.service
      .settings()
      .toPromise()
      .then((res) => window.open(res.url, "_self"));
  }
}
